module.exports = __webpack_public_path__ + "img/img2.da188fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2.png
// module id = xx0f
// module chunks = 2